import React from "react";

interface QueueItem {
    promise(): Promise<unknown>;
    resolve(value: unknown): void;
    reject(value: unknown): void;
}
interface HookReturn {
    queue: QueueItem[];
    enqueue(promise: () => Promise<unknown>): Promise<unknown>;
    dequeue(): void;
}

const useQueue = (): HookReturn => {
    const queueRef = React.useRef<QueueItem[]>([]);
    const workingRef = React.useRef<boolean>(false);

    const dequeue = () => {
        if (workingRef.current) {
            return false;
        }
        const item = queueRef.current.shift();
        if (!item) {
            return false;
        }
        try {
            workingRef.current = true;
            item.promise()
                .then((value) => {
                    workingRef.current = false;
                    item.resolve(value);
                    dequeue();
                })
                .catch((err) => {
                    workingRef.current = false;
                    item.reject(err);
                    dequeue();
                });
        } catch (err) {
            workingRef.current = false;
            item.reject(err);
            dequeue();
        }
        return true;
    };
    const enqueue = (promise: () => Promise<unknown>): Promise<unknown> =>
        new Promise((resolve, reject) => {
            const newQueue = queueRef.current.concat([
                {
                    promise,
                    resolve,
                    reject,
                },
            ]);
            queueRef.current = newQueue;
            dequeue();
        });
    return {
        queue: queueRef.current,
        enqueue,
        dequeue,
    };
};
export default useQueue;
